export function addParam(url :string,param :string,value :string){
  //for location and blowing up on null
  url = url.toString();
  
  if(url.indexOf('?')===-1){
    url+='?';
  }else if(url.lastIndexOf('&')!==url.length){
    url+='&';
  }
  if(arguments.length>2){
    url += encodeURIComponent(param)+'='+encodeURIComponent(value);
  }else{
    url += param;
  }
  return url;
}

export function addParams(url :string,keyVal :{[x:string]:string}){
  url = url.toString();
  let sep = '';
  if(url.indexOf('?')===-1){
    sep ='?';
  }else if(url.charAt(url.length-1)!=='&' && url.charAt(url.length-1)!=='?'){
    sep = '&';
  }
  for(let i in keyVal){
    let val = keyVal[i];
    if(val!==undefined && val!==null){
      url += sep + encodeURIComponent(i)+'='+encodeURIComponent(keyVal[i]);
      sep = '&';
    }
    
  }
  return url;
}
export function resolve(base :string,target :string){
  var 
    baseSplitted = base.split('/'),
    targetSplitted = target.split('/'),
    result = [];
  baseSplitted.pop();
  baseSplitted.forEach(function(item){
    result.push(item);
  })
  targetSplitted.forEach(function(item){
    if(item==='.'){
    }else if(item==='..'){
      result.pop();
    }else{
      result.push(item);
    }
  })
  return result.join('/');
}